// extracted by mini-css-extract-plugin
export default {"chipLabel":"DDeXQx6lj2iPKiC3QkKR"};